module.exports = "/ui/fonts/revicons.woff";